import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CustomPagesService } from '@features/custom-pages';
import { CommonModule } from '@angular/common';

import { NewsletterComponent } from './components/newsletter';
import { PartnersComponent } from './components/partners';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  imports: [RouterModule, CommonModule, NewsletterComponent, PartnersComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class FooterComponent {
  protected today = new Date();

  #pages = inject(CustomPagesService);

  protected navigation = computed(() => this.#pages.navigation().footer_items);

  protected navRoute = CustomPagesService.navRoute;
}
